import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface AreaChartProps {
    seriesData: { name: string; data: number[] }[];
    xaxisCategories: string[];
    color:string[];
}

const AreaChart: React.FC<AreaChartProps> = ({seriesData,xaxisCategories,color}) => {
    // console.log("xaxisCategories",xaxisCategories)
        // Replicate single data points to ensure the area is colored
        const updatedSeriesData = seriesData.map(data => {
            if (data.data.length === 1) {
                return {
                    ...data,
                    data: [data.data[0], data.data[0]] // Add extra points to replicate a single data point
                };
            }
            return data;
        });

        const updatedCategories = xaxisCategories.length === 1
            ? [xaxisCategories[0], xaxisCategories[0]]
            : xaxisCategories;

        // console.log("xaxisCategories===",xaxisCategories)
        
    // const seriesData = [{
    //     name: 'Series 1',
    //     data: [4.5,2.5]
    // }];

    // const xaxisCategories = ['01/02/23','28/02/23'];
    const chartOptions: ApexOptions = {
        chart: {
            type: 'area',
            fontFamily: "Sora, system-ui, sans-serif",
            foreColor: "#627771",
            toolbar: {
                show: false // Hide the zoom bar
            },
        },
        tooltip: {
            enabled: false // Disable the tooltip
        },
        
        xaxis: {
            categories: updatedCategories,
            axisBorder: { color: "#DDE7E4" },
            axisTicks: { color: "#DDE7E4" },
        },
        yaxis: {
            min: 0, // Start y-axis from 0
            max: 5,
            labels: {
                formatter: function (val) {
                    return Math.round(val).toString(); // Format y-axis labels to display whole numbers
                }
            }  ,
            forceNiceScale: false
            
        },
        grid: {
            show: true,
            borderColor: "#E8EFED",
            strokeDashArray: 3
        },
        colors: color, 
        fill: {
            type: 'gradient',
            colors: color // Background color under the curve
        },
    };

    return (
        <div role="img" aria-label={`${seriesData[0]?.name || "Rating"} performance trend`}>
            <ReactApexChart options={chartOptions} series={updatedSeriesData} type="area" height={250} width={'100%'} />
        </div>
    );
};

export default AreaChart;
